import script from "./ViewHealthGoals.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewHealthGoals.vue?vue&type=script&setup=true&lang=ts"

import "./ViewHealthGoals.vue?vue&type=style&index=0&id=55360953&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55360953"]])

export default __exports__